<div class="settings-page">
  <!-- Page header -->
  <header class="settings-header">
    <div class="settings-header__badge">
      <mat-icon>settings</mat-icon>
    </div>
    <div class="settings-header__text">
      <h1 class="settings-header__title">Settings</h1>
      <p class="settings-header__subtitle">Manage loan servicing reference data and configuration</p>
    </div>
  </header>

  <mat-sidenav-container class="settings-container" autosize>
    <mat-sidenav mode="side" opened disableClose class="settings-nav">
      <p class="settings-nav__label">General</p>
      <mat-nav-list>
        <a mat-list-item routerLink="fif-branch" routerLinkActive="active-link">
          <mat-icon matListItemIcon>account_balance</mat-icon>
          <span matListItemTitle>Fif branch</span>
        </a>
        <a mat-list-item routerLink="nls-customer-validation" routerLinkActive="active-link">
          <mat-icon matListItemIcon>verified_user</mat-icon>
          <span matListItemTitle>NLS Customer Validation</span>
        </a>
        <a mat-list-item routerLink="payment-errors" routerLinkActive="active-link">
          <mat-icon matListItemIcon>report_problem</mat-icon>
          <span matListItemTitle>Payment errors</span>
        </a>
      </mat-nav-list>
    </mat-sidenav>

    <mat-sidenav-content class="settings-content">
      <router-outlet></router-outlet>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>